import React from 'react'

import Section from 'components/common/Section'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'

import { JiraIntegration } from './user-integrations/JiraIntegration'

const UserIntegrations = () => {
  const { currentTeamId } = useAuth()

  const { isLoading, error, hasError, doFetch } = useAgent(
    `/external-integrations?type=jira&teamId=${currentTeamId}`,
    null,
    {
      shouldCache: true
    }
  )

  const hasJiraErrorDifferentFromNotFound =
    hasError && (error?.[0]?.response?.status ?? 500) !== 404

  return (
    <Section
      errorMessage="Integrations could not be loaded at this time."
      hasError={hasJiraErrorDifferentFromNotFound}
      isLoading={isLoading}
    >
      <JiraIntegration isConnected={!hasError} onChanged={doFetch} />
    </Section>
  )
}

export default UserIntegrations
